// webapp/src/hooks/useModalScrollLock.ts
// If your file already exists, replace its contents with this simplified, safe version.
import * as React from 'react';

const LOCK_COUNT_KEY = 'modalScrollLockCount';
const PREV_OVERFLOW_KEY = 'modalScrollLockPrevOverflow';
const PREV_PADDING_KEY = 'modalScrollLockPrevPaddingRight';

export function useModalScrollLock(isOpen: boolean) {
  React.useEffect(() => {
    if (!isOpen || typeof document === 'undefined' || typeof window === 'undefined') return;

    const body = document.body;
    const currentCount = Number(body.dataset[LOCK_COUNT_KEY] ?? '0');

    if (currentCount === 0) {
      body.dataset[PREV_OVERFLOW_KEY] = body.style.overflow;
      body.dataset[PREV_PADDING_KEY] = body.style.paddingRight;

      const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      if (scrollbarWidth > 0) {
        const computed = window.getComputedStyle(body).paddingRight;
        const currentPadding = Number.parseFloat(computed || '0');
        body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
      }
      body.style.overflow = 'hidden';
    }

    body.dataset[LOCK_COUNT_KEY] = String(currentCount + 1);

    return () => {
      const nextCount = Math.max(0, Number(body.dataset[LOCK_COUNT_KEY] ?? '1') - 1);
      body.dataset[LOCK_COUNT_KEY] = String(nextCount);

      if (nextCount > 0) return;

      const previousOverflow = body.dataset[PREV_OVERFLOW_KEY] ?? '';
      const previousPaddingRight = body.dataset[PREV_PADDING_KEY] ?? '';
      body.style.overflow = previousOverflow;
      body.style.paddingRight = previousPaddingRight;
      delete body.dataset[LOCK_COUNT_KEY];
      delete body.dataset[PREV_OVERFLOW_KEY];
      delete body.dataset[PREV_PADDING_KEY];
    };
  }, [isOpen]);
}
